import EzController from 'controllers/ez-base-controller';
import events from 'lib/events';
import { triggerCustomEvent } from 'lib/helpers';

export default class ResourceShareController extends EzController {
  connect() {
    this.flagLoaded();
  }

  sendAnalytics() {
    triggerCustomEvent(events.show_page.share, {
      resourceContentType: this.data.get('contentType'),
    });
  }

  sendPinterestAnalytics() {
    triggerCustomEvent(events.show_page.share, {
      resourceContentType: this.data.get('contentType'),
    });
  }
}
